module.exports = __webpack_public_path__ + "static/img/lhz.28a90e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/lhz.jpg
// module id = 4HOt
// module chunks = 0